/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Option } from './option';
import { QuestionTypeEnum } from './questionTypeEnum';

/**
 * options field is filled only if question_type is 'option'
 */
export interface Question { 
    questionType: QuestionTypeEnum;
    options?: Array<Option>;
    value?: string;
    id?: number;
    uuid?: string;
    title: string;
    visibleTitle: boolean;
}